import React from 'react'

const styles = {
    backgroundColor: "#C00",
    padding: "3px 5px",
    borderRadius: "1.75em",
    color: "#FFF",
    fontSize: ".6rem",
    position: "relative"
}
export default function BubleCart({value}) {
    const getQuantity = (amount) => {
        if(!amount) return;
        return amount > 9 ? '9+' : amount;
    }
    return (
        <>
            <span style= {styles}>{getQuantity(value)}</span>
        </>
    )
}
